export default __webpack_public_path__ + "static/media/nestle.16a01325.svg";